<i18n
  src="@/locales/views/packing_house/process/exec_steps/new_exec_step.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/process_line_exec_input.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exported_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_package.yml" lang="yaml"></i18n>
<template>
  <div class="col-span-2 sm:col-span-1">
    <label class="label-form">
      {{ $t("model.process_line_exec_input.process_line_product") }}
    </label>
    <div v-if="process_line_input_products.length > 0" class="mt-1">
      <select-form
        :options="process_line_input_products"
        v-model="process_line_exec_input.process_line_product_id"
        :is_invalid="isInvalidSelect('process_line_product')"
      />
    </div>
  </div>

  <div
    v-if="process_line_step.previous_step_id"
    class="col-span-2 sm:col-span-1"
  >
    <label class="label-form">
      {{ $t("model.process_line_exec_input.process_line_exec_output") }}
    </label>
    <div v-if="process_line_exec_outputs.length > 0" class="mt-1">
      <select-form
        :options="process_line_exec_outputs"
        v-model="process_line_exec_input.process_line_exec_output_id"
        :is_invalid="isInvalidSelect('process_line_exec_output')"
      />
    </div>
  </div>

  <template v-else>
    <div class="col-span-2 sm:col-span-1">
      <label class="label-form">
        {{ $t("model.process_line_exec_input.input_code") }}
      </label>
      <div class="mt-1">
        <input
          type="text"
          v-model.trim="process_line_exec_input.input_code"
          :class="['input-text', isInvalid('input_code')]"
        />
      </div>
    </div>

    <div class="col-span-2 sm:col-span-1">
      <label class="label-form">
        {{ $t("model.process_line_exec_input.value") }}
      </label>
      <div class="mt-1">
        <input
          type="text"
          v-model.trim="process_line_exec_input.value"
          :class="['input-text', isInvalid('value')]"
        />
      </div>
    </div>

    <div class="col-span-2 sm:col-span-1">
      <label class="label-form">
        {{ $t("model.process_line_exec_input.unit") }}
      </label>
      <div class="mt-1">
        <input
          type="text"
          v-model="process_line_exec_input.unit"
          :class="['input-text', isInvalid('unit')]"
        />
      </div>
    </div>
  </template>

  <template v-if="process_line_input_product?.has_harvested_batch">
    <div class="col-span-2 sm:col-span-1">
      <label class="label-form">
        {{ $t("model.harvested_batch.producer") }}
      </label>
      <div class="mt-1">
        <select-form
          v-if="producers.length > 0"
          :options="producers"
          label="label"
          v-model="process_line_exec_input.harvested_batch.producer_id"
          :is_invalid="isInvalidSelect('producer')"
        />
      </div>
    </div>
    <div class="col-span-2 sm:col-span-1">
      <label class="label-form">
        {{ $t("model.harvested_batch.crop_field") }}
      </label>
      <div class="mt-1" v-if="crop_fields_harvest.length > 1">
        <select-form
          :options="crop_fields_harvest"
          v-model="process_line_exec_input.harvested_batch.crop_field_id"
          :is_invalid="isInvalidSelect('crop_field')"
        />
      </div>
      <dd class="content-data" v-else-if="crop_fields_harvest.length == 1">
        {{ crop_fields_harvest[0].name }}
      </dd>
    </div>
    <template v-if="process_line_input_product?.has_exported_batch">
      <div class="col-span-2 sm:col-span-1">
        <label class="label-form">
          {{ $t("labels.formalized_producer") }}
        </label>
        <div class="mt-1">
          <select-form
            v-if="producers_formalized.length > 0"
            :options="producers_formalized"
            label="label"
            v-model="process_line_exec_input.exported_batch.producer_id"
            :is_invalid="isInvalidSelect('producer')"
          />
        </div>
      </div>
      <div class="col-span-2 sm:col-span-1">
        <label class="label-form">
          {{ $t("labels.formalized_crop_field") }}
        </label>
        <div class="mt-1" v-if="crop_fields_export.length > 1">
          <select-form
            :options="crop_fields_export"
            v-model="process_line_exec_input.exported_batch.crop_field_id"
            :is_invalid="isInvalidSelect('crop_field')"
          />
        </div>
        <dd class="content-data" v-else-if="crop_fields_export.length == 1">
          {{ crop_fields_export[0].name }}
        </dd>
      </div>
    </template>
    <div class="col-span-2 sm:col-span-1" v-if="crop_types.length > 1">
      <label class="label-form">
        {{ $t("model.harvested_batch.crop_type") }}
      </label>
      <div class="mt-1">
        <select-form
          :options="crop_types"
          v-model="process_line_exec_input.harvested_batch.crop_type_id"
          :is_invalid="isInvalidSelect('crop_type')"
        />
      </div>
    </div>
    <div
      v-if="agro_exporter_processes.length > 1"
      class="col-span-2 sm:col-span-1"
    >
      <label class="label-form">
        {{ $t("model.exported_batch.agro_exporter_process") }}
      </label>
      <div class="mt-1" v-if="agro_exporter_processes.length > 1">
        <select-form
          :options="agro_exporter_processes"
          v-model="
            process_line_exec_output.harvested_batch.agro_exporter_process_id
          "
          :is_invalid="isInvalidSelect('agro_exporter_process')"
        />
      </div>
    </div>
  </template>
</template>

<script>
import Requester from "@/views/packing_house/requesters/process/exec_steps/new_exec_step.js";
export default {
  name: "PHProcessExecStepsExecStepInputForm",
  components: {},
  data() {
    return {
      process_line_exec_input: this.modelValue,
      process_line_exec_outputs: [],
      producers: [],
      producers_formalized: [],
      crop_fields_harvest: [],
      crop_fields_export: [],
      agro_exporter_processes: [],
      crop_types: [],
    };
  },
  props: {
    packing_house_id: {
      required: true,
    },
    packing_house_process_id: {
      required: true,
    },
    process_line_step: {
      required: true,
    },
    process_line_input_products: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Object,
      required: true,
    },
  },
  created() {
    if (this.modelValue.harvested_batch?.id) {
      this.fetchAgroExporterProcesses();
      this.fetchProducers();
      this.fetchCropTypes();
      this.fetchCropFieldsHarvest();
      this.fetchCropFieldsExport();
    } else if (this.process_line_input_products.length == 1) {
      this.process_line_exec_input.process_line_product_id =
        this.process_line_input_products[0].id;
    }

    if (
      this.process_line_step.previous_step_id &&
      this.process_line_exec_input.process_line_exec_output_id
    ) {
      this.fetchProcessLineExecOutputs();
    }
  },
  computed: {
    process_line_input_product: function () {
      return this.process_line_input_products.find(
        (product) =>
          product.id === this.process_line_exec_input.process_line_product_id
      );
    },
  },
  methods: {
    fetchAgroExporterProcesses: async function () {
      const response = await Requester.fetchAgroExporterProcesses(
        this.packing_house_id,
        this.packing_house_process_id
      );
      this.agro_exporter_processes = response.data;
      if (this.agro_exporter_processes.length == 1) {
        this.process_line_exec_input.harvested_batch.agro_exporter_process_id =
          this.agro_exporter_processes[0].id;
        this.process_line_exec_input.exported_batch.agro_exporter_process_id =
          this.agro_exporter_processes[0].id;
      }
    },
    fetchProducers: async function () {
      const response = await Requester.fetchProducers(
        this.packing_house_id,
        this.packing_house_process_id
      );
      this.producers = response.data;
      this.producers_formalized = this.producers.filter(
        (producer) => producer.formalized
      );
    },
    fetchCropFields: async function (producer_id) {
      return await Requester.fetchCropFields(
        this.packing_house_id,
        this.packing_house_process_id,
        producer_id
      );
    },
    fetchCropFieldsHarvest: async function () {
      const response = await this.fetchCropFields(
        this.process_line_exec_input.harvested_batch.producer_id
      );
      this.crop_fields_harvest = response.data;
      if (this.crop_fields_harvest.length == 1) {
        this.process_line_exec_input.harvested_batch.crop_field_id =
          this.crop_fields_harvest[0].id;
      }
    },
    fetchCropFieldsExport: async function () {
      const response = await this.fetchCropFields(
        this.process_line_exec_input.exported_batch.producer_id
      );
      this.crop_fields_export = response.data;
      if (this.crop_fields_export.length == 1) {
        this.process_line_exec_input.exported_batch.crop_field_id =
          this.crop_fields_export[0].id;
      }
    },
    fetchCropTypes: async function () {
      const response = await Requester.fetchCropTypes(this.packing_house_id);
      this.crop_types = response.data;
    },
    fetchProcessLineExecOutputs: async function () {
      const response = await Requester.fetchProcessLineExecOutputs(
        this.packing_house_id,
        this.process_line_step.id,
        this.process_line_exec_input.process_line_product_id,
        this.process_line_exec_input.id
      );
      this.process_line_exec_outputs = response.data;
      this.process_line_exec_outputs.forEach((output) => {
        output[
          "name"
        ] = `${output.output_code} - ${output.value} ${output.unit}`;
      });
    },
  },
  watch: {
    "process_line_exec_input.process_line_product_id": function (newValue) {
      this.process_line_exec_input.unit =
        this.process_line_input_products.find(
          (product) => product.id === newValue
        )?.unit || "";

      this.process_line_exec_input.process_line_exec_output_id = null;
      this.process_line_exec_outputs = [];
      if (newValue) {
        this.fetchProcessLineExecOutputs();
      }
    },
    "process_line_exec_input.process_line_exec_output_id": function (newValue) {
      const process_line_exec_output = this.process_line_exec_outputs.find(
        (output) => output.id === newValue
      );
      if (!process_line_exec_output) return;
      this.process_line_exec_input.value = process_line_exec_output.value;
      this.process_line_exec_input.unit = process_line_exec_output.unit;
      this.process_line_exec_input.input_code =
        process_line_exec_output.output_code;
    },
    process_line_exec_input: {
      handler(newValue) {
        this.$emit("update:modelValue", newValue);
      },
      deep: true,
    },
    process_line_input_product: function (newValue) {
      if (newValue?.has_harvested_batch) {
        this.fetchCropTypes();
        this.fetchProducers();
        this.fetchAgroExporterProcesses();
      } else {
        this.producers = [];
        this.crop_fields_harvest = [];
        this.crop_fields_export = [];
        this.crop_types = [];
      }
    },

    "process_line_exec_input.harvested_batch.producer_id": function (
      new_value
    ) {
      this.process_line_exec_input.harvested_batch.crop_field_id = null;
      this.process_line_exec_input.harvested_batch.crop_variety_id = null;
      this.crop_fields_harvest = [];
      if (new_value) this.fetchCropFieldsHarvest();
    },
    "process_line_exec_input.exported_batch.producer_id": function (new_value) {
      this.process_line_exec_input.exported_batch.crop_field_id = null;
      this.crop_fields_export = [];
      if (new_value) this.fetchCropFieldsExport();
    },
    "process_line_exec_input.harvested_batch.crop_field_id": function (
      new_value
    ) {
      const crop_field = this.crop_fields_harvest.find(
        (field) => field.id === new_value
      );
      if (new_value) {
        this.process_line_exec_input.harvested_batch.crop_variety_id =
          crop_field?.crop_variety_id;
      }
    },
    "process_line_exec_input.harvested_batch.agro_exporter_process_id":
      function (new_value) {
        this.process_line_exec_input.exported_batch.agro_exporter_process_id =
          new_value;
      },
  },
};
</script>
